import React, { Component } from "react"
import { Form } from "app/forms/form"
import * as Elements from "app/forms/elements"

import thumbnail from "app/forms/images/templates/charlotte.jpg"

class Charlotte extends Component {
  static displayName = "Charlotte"
  static style = "form"
  static formats = ["inline", "modal", "slide in"]
  static thumbnail = thumbnail
  static fields = [
    {
      name: "first_name",
      label: "Your first name"
    },
    {
      name: "email_address",
      label: "Your email address"
    }
  ]

  render() {
    const { elements, styles, ...props } = this.props

    return (
      <Form
        {...props}
        style={styles.forElement("form", {
          backgroundColor: "#ffffff",
          borderRadius: 4
        })}
      >
        <div data-style="full">
          <div
            data-element="column"
            style={styles.forElement("background")}
            className="formkit-background"
          />
          <div data-element="column" className="formkit-column">
            <Elements.Header
              tag="h2"
              name="header"
              defaults={{ content: "Get our how to guide" }}
            />
            <Elements.Errors />

            <Elements.CustomFields>
              <Elements.AddFieldButton />
              <Elements.Button
                name="submit"
                group="button"
                defaults={{ content: "Send me the guide" }}
              />
            </Elements.CustomFields>

            <Elements.Content
              name="disclaimer"
              defaults={{
                content: "We respect your privacy. Unsubscribe at anytime."
              }}
            />

            <Elements.BuiltWith background="form" />
          </div>
        </div>
      </Form>
    )
  }
}

Charlotte.displayName = "Charlotte"

export default Charlotte
